import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';

import { getOrdersApi } from '../services/OrderService';

const columns = [
  {
    field: 'id',
    headerName: 'ID',
    width: 30
  },
  {
    field: 'police_name',
    headerName: 'Nombre Policía',
    width: 150,
    //editable: true, TODO: are you?
    sortable: false
  },
  {
    field: 'number',
    headerName: 'Número',
    type: 'number',
    width: 250,
    sortable: false
  },
  {
    field: 'cui',
    headerName: 'CUI',
    type: 'number',
    width: 250,
    sortable: false
  },
  {
    field: 'order_type',
    headerName: 'Tipo de Orden',
    width: 120,
    sortable: false
  },
  {
    field: 'observation',
    headerName: 'Observación',
    width: 200,
    sortable: false
  },
  {
    field: 'delivery_status',
    headerName: 'Estado de Entrega',
    width: 150,
    sortable: false
  },
  {
    field: 'created_at',
    headerName: 'Fecha Creación',
    width: 170,
    sortable: false
  },
  {
    field: 'remainders',
    headerName: 'Recordatorios',
    width: 170,
    sortable: false,
    valueGetter: (params) => {
      return params.row.remainders[0]?.target_date;
    }
  },
];

const OrderTableComponent = (props) => {
  const [rows, setRows] = useState([]);
  const reloadRows = props.reloadRows;
  const setReloadRows = props.onSetReloadRows;

  const fetchHandler = () => {
    getOrdersApi(localStorage.getItem('token'), localStorage.getItem('user_id'), props.filter)
      .then((data) => {
        setRows(data);
      }).catch((errors) => {
        // TODO: Handle errors
      });
  };

  useEffect(() => {
    if (reloadRows) {
      fetchHandler();
      setReloadRows(false);
    }
  }, [reloadRows])

  return (
    <Box sx={{ width: '80vw', height: '50vh' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={6}
        rowsPerPageOptions={[6]}
        disableSelectionOnClick
      />
    </Box>
  );
}

export default OrderTableComponent;
